import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../../core/services/dataBean/useDataBean';
import { _AdquisitionContractvdos, _ProductLot, _RawMaterialByProductionOrder } from '../../../../../../../core/services/dataBean/EntityCatalogVdos';
import { BasicMultiSelectTable } from '../../../../../../theme/Component/BasicMultiSelecTable';
import { BasicTable, MASK_DATE, MASK_MONEY } from '../../../../../../theme/Component/BasicTable';
import { ListMenu } from '../../../../../../theme/Component/ListMenu';
import { _AdquisitionContract, _single } from '../../../../../../../core/services/dataBean/EntityCatalog';
import { Modal } from '../../../../../../theme/Component/Modal';
import { InputDate } from '../../../../../../theme/Input/InputDate';
import { ProductionOrderEditor } from '../../../../../../Factoty&Production/ProductionOrder/ProductionOrderEditor';
import { BasicButton } from '../../../../../../theme/Component/BasicButton';
import { AccountEditor } from '../../../../../../editor/AccountEditor';



interface Props {

    data?: any;
    idSelector: number;

    onChange: any;
    label?: string;
}

export const SelectAdquisitionContract = ({ data, idSelector, onChange, label }: Props) => {

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [listaResult, setListaResult] = useState<any>([]);
    const AdquisitionContract = useDataBean(_AdquisitionContract);
    const [idAcc, setIDAcc] = useState<number>(null);
    const [render, setRender] = useState<string>('');
    // const [bean, setBean] = useState<any>({});
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {

        if (data) {
            setIDAcc(data.IDAccount);
        }

    }, [data])

    useEffect(() => {
        getLista();
    }, [idAcc])

    useEffect(() => {
        onChange({
            DataBeanProperties: AdquisitionContract.bean,
            DataBeanName: 'com.orange.bean.AdquisitionContract'
        });
        setRender(AdquisitionContract.bean.InternalCode);
    }, [AdquisitionContract.bean])


    const getLista = () => {
        const props = {
            IDAccount: idAcc,
            State: 1
        }
        AdquisitionContract.instance.getAdquisitionContractRender(null, null, props, null, null).then(
            (resp) => {
                setLista(resp)
                console.log(resp)
            }
        )
    }

    const headMulti = [
        { title: 'ID', property: 'IDAdquisitionContract', visible: true },
        { title: 'Valor Contrato', property: 'ContractValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor CDP', property: 'CDPValue', visible: false },
        { title: 'Fecha Contrato', property: 'SeleccionDate', visible: true, mask: MASK_DATE },
        { title: 'Fecha Final', property: 'EndContractDate', visible: true, mask: MASK_DATE },

        { title: 'Código contrato', property: 'InternalCode', visible: false },
        { title: 'Proveedor', property: 'Name1', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'No CDP', property: 'NoCDP', visible: false },
        { title: 'Fecha CDP', property: 'DateCDP', visible: false },
        { title: 'No registro presupuestal', property: 'NoRegistroPresupuestal', visible: false },
        { title: 'Fecha registro presupuestal', property: 'DateRegPresupuestal', visible: false },
    ]
    const abrirmodal = () => {
        setModal({ ...modal, "view": true, "name": "Selecciona una Fila*" });
    }



    return (
        <>

            <div className="row">
                <div className="col-md-12 mt-2">
                    {/* <BasicButton icon="ri-send-plane-2-line" clase="primary" eventClick={abrirmodal}>Contratos de Adquisición</BasicButton> */}
                    <label >{label ?? 'Contrato'}</label>
                    <input type="text" className='form-control' readOnly placeholder={render} onClick={abrirmodal} />
                </div>
            </div>



            <Modal modal={modal} updateModal={setModal}>
                <>
                    <label>{label ?? "Contratos de Adquisición"}</label>
                    <AccountEditor idAccount={idAcc} label="Tercero" onChange={(e) => { setIDAcc(e.IDAccount) }} />
                    <BasicTable head={headMulti} body={lista} rowSet={AdquisitionContract.setBean} />

                </>
            </Modal>


        </>
    )
}